import React, { useState, useEffect } from "react";
import { busApi } from "../../services/api/busApi";

function LinhasOnibus({ onLinhaSelect }) {
  const [linhas, setLinhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const collator = new Intl.Collator("pt-BR", {
    numeric: true,
    sensitivity: "base",
  });

  useEffect(() => {
    const fetchLinhas = async () => {
      setLoading(true);
      try {
        const response = await busApi.getRoutes(searchTerm);
        setLinhas(response.data);
      } catch (error) {
        console.error("Erro ao buscar linhas:", { error, searchTerm });
      } finally {
        setLoading(false);
      }
    };

    const delayDebounceFn = setTimeout(() => fetchLinhas(), 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const sortedLinhas = [...linhas].sort((a, b) => {
    const keyA = String(a?.shortName ?? a?.routeId ?? "");
    const keyB = String(b?.shortName ?? b?.routeId ?? "");
    const primary = collator.compare(keyA, keyB);
    if (primary !== 0) return primary;
    return collator.compare(
      String(a?.routeId ?? ""),
      String(b?.routeId ?? "")
    );
  });

  return (
    <div className="sheet-linhas-container">
      <h2>Linhas de Ônibus</h2>
      <input
        type="text"
        placeholder="Buscar linha (ex: 2109)"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      {loading ? (
        <p className="py-5 text-center text-muted">
          Carregando...
        </p>
      ) : (
        <ul className="linhas-list">
          {sortedLinhas.length > 0 ? (
            sortedLinhas.map((linha) => (
              <li
                key={linha.routeId}
                onClick={() => onLinhaSelect && onLinhaSelect(linha)}
              >
                <span
                  className="linha-cor"
                  style={{ backgroundColor: linha.color }}
                ></span>
                <span className="min-w-0 flex-1 break-words leading-snug">
                  <strong>{linha.shortName}</strong> - {linha.longName}
                </span>
              </li>
            ))
          ) : (
            <p className="py-5 text-center text-muted">
              Nenhuma linha encontrada.
            </p>
          )}
        </ul>
      )}
    </div>
  );
}

export default LinhasOnibus;
